<template>
    <v-container fluid pt-1 pa-0 v-if="!$store.getters.progress" style="padding-bottom: 10% !important">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="flex pa-0">
                    <v-toolbar flat color="grey lighten-4">
                        <v-toolbar-title class="grey--text text--darken-4">Dettaglio Utente</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn @click="$eventBusUtility.goTo($router, 'users-edit', model.id)" slot="activator" icon>
                                <v-icon color="primary">mode_edit</v-icon>
                            </v-btn>
                            <span>Modifica Utente</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-divider></v-divider>

                    <v-container fluid pa-0 px-2>
                        <v-layout row :wrap="$vuetify.breakpoint.smAndDown">
                            <v-flex :class="styleClass">
                                    <v-list two-line class="w100p">
                                        <v-subheader>Utente</v-subheader>
                                        <v-list-tile>
                                            <v-list-tile-avatar class="v-avatar-show">
                                                <v-avatar
                                                    v-if="model.avatar"
                                                    class="custom-avatar"
                                                    :size="26"
                                                    v-ripple
                                                    :style="{'background-image': 'url(' + model.avatar + ')'}">
                                                </v-avatar>
                                                <v-avatar v-else :class="$eventBusUtility.bgColor(model.id)" :size="26">
                                                    <span class="white--text fs14" v-if="model.name">{{ model.name.charAt(0) }}</span>
                                                </v-avatar>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Nome</v-list-tile-title>
                                                <v-list-tile-sub-title>{{ model.name }}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>                                    
                                        <v-list-tile>
                                            <v-list-tile-action>
                                                <v-icon color="primary">email</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Email</v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    <a target="_blank" :href="'mailto:'+model.email">{{ model.email }}</a>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>                              
                                        <v-list-tile>
                                            <v-list-tile-avatar class="v-avatar-show">
                                                <v-avatar v-if="model.creator_avatar"
                                                    class="custom-avatar"
                                                    :size="26" 
                                                    v-ripple
                                                    :style="{'background-image': 'url(' + model.creator_avatar + ')'}">
                                                </v-avatar>
                                                <v-avatar v-else :class="$eventBusUtility.bgColor(model.creator_id)" :size="26">
                                                    <span class="white--text fs14" v-if="model.creator">{{ model.creator.charAt(0) }}</span>
                                                </v-avatar>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Creatore</v-list-tile-title>
                                                <v-list-tile-sub-title>{{ model.creator }}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>                              
                                    </v-list>
                                </v-flex>

                            </v-layout>

                        <v-divider v-if="model.description"></v-divider>
                        <v-layout row wrap pt-2 pb-2 v-if="model.description">
                            <template>
                                <v-subheader class="pl-4 pt-3">Descrizione</v-subheader>
                                <v-flex xs12>
                                    <v-card class="flex" elevation="0">
                                        <div class="blockquote pl-4 pr-4 fs14i" v-html="model.description"></div>
                                    </v-card>
                                </v-flex>
                            </template>     
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12 pt-3>
                <crud 
                    action-icon='today'
                    model-def='calendars'
                    title="Calendari"
                    :sub-filters="{user_id: id}"
                    action-position='absolute'
                    :default-input='{user_id: id}'
                    :positionLeft="true"
                    :positionRight="false"
                    direction="right"
                    :crudDialog="true"
                ></crud>
            </v-flex>
        </v-layout>

    </v-container>
</template>
<script>
export default {
	name: 'user',
	props: {
		id: Number
	},

	data() {
		return {
			model: {},
			url: 'users/',
			styleClass: ['xs12', 'sm12', 'md6']
		}
	},

	created() {
		this.axios.get(this.url + this.id).then(response => {
			// get body data
			this.model = response.data.model
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
		})
	}
}
</script>

<style>
</style>
